import { RequestLayer, Interceptors } from '@jotforminc/request-layer';

export default new RequestLayer('/API', {
  interceptorConfig: {
    teamID: global.teamID,
    customResponseInterceptors: [Interceptors.requestManagerResponseNormalizer]
  }
});
